import React, { FC, useState } from "react";
import { BurgerMenuDark, DarkMobileLogo, NavCloseIconDark } from "assets/svgs/nav";
import { NewNavInterface } from "containers/common/sections/layout/Nav/Nav";
import MobileAppLink from "containers/common/sections/MobileAppLink";
import { css } from "@emotion/css";
import { Theme } from "evcharging/app/themes";
import useTheme from "evcharging/hooks/useTheme";
import NavLinkDropdownMobile from "containers/common/sections/layout/NewNav/NavLinkDropdownMobile";
import { PageLink } from "components/common/atoms";
import useI18n from "evcharging/hooks/useI18n";
import { dropdownOptions } from "evcharging/providers/ServicesProvider";

const MobileMenu: FC<NewNavInterface> = () => {
  const { t } = useI18n();
  const theme = useTheme();
  const classes = createStyles(theme);

  const [open, setOpen] = useState<boolean>(false);
  const toggleMenu = () => setOpen(!open);

  const CloseIcon: FC = () => <NavCloseIconDark />;
  const MenuIcon: FC = () => <BurgerMenuDark />;

  return (
    <>
      <MobileAppLink />
      <div className={classes.topNav}>
        <div className={classes.container}>

          <div className={classes.topPanel}>
            <PageLink href="/" aria-label={"Theme Logo"}>
              <DarkMobileLogo />
            </PageLink>
            <button
              onClick={toggleMenu}
              aria-label="menu"
              className={classes.burgerIcon}
            >
              {open ? <CloseIcon /> : <MenuIcon />}
            </button>
          </div>

          <div style={{display: open ? 'block' : 'none'}}>
            <nav className={classes.list}>
              <PageLink href={"/"}>
                <div className={classes.itemText}>{t('nav.home')}</div>
              </PageLink>
              <PageLink href={"/about-us"}>
                <div className={classes.itemText}>{t('nav.about')}</div>
              </PageLink>
              <NavLinkDropdownMobile links={dropdownOptions} label={t('nav.services')} />
              {/*<PageLink href={"/blog"}>
                <div className={classes.itemText}>{t('nav.blog')}</div>
              </PageLink>*/}
              {/*<PageLink href={"/our-providers"}>
                <div className={classes.itemText}>{t('nav.providers')}</div>
              </PageLink>*/}
              <PageLink href={"/contact-us"}>
                <div className={classes.itemText}>{t('nav.contact')}</div>
              </PageLink>
              <PageLink href={"/faq"}>
                <div className={classes.itemText}>{t('nav.faq')}</div>
              </PageLink>
            </nav>
          </div>
        </div>
      </div>
    </>
  );
};

const createStyles = (theme: Theme) => ({
  topNav: css({
    height: 68,
    backgroundColor: "#333",
    boxShadow: "none",
    width: "100%"
  }),
  container: css({
    height: "100%",
    padding: theme.spacing(1.4, 2.5)
  }),
  topPanel: css({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  }),
  itemText: css({
    fontSize: 16,
    color: "#fff",
    fontWeight: 600
  }),
  newTopNavTransparent: css({
    backgroundColor: "transparent"
  }),
  blockIcon: css({
    marginRight: theme.spacing(-2),
    [theme.breakpoints.mobile.down]: {
      marginRight: theme.spacing(1)
    }
  }),
  burgerIcon: css({
    background: 'none',
    border: 'none',
    "&:hover": {
      backgroundColor: "transparent "
    },
    "& svg rect": {
      fill: '#fff'
    },
    "& svg path": {
      stroke: '#fff'
    }
  }),
  normalBg: css({
    fill: theme.colors.accent,
    stroke: "none"
  }),
  list: css({
    position: "absolute",
    left: 0,
    width: "100%",
    background: "#333",
    zIndex: 10000,
    padding: theme.spacing(1, 0, 0),
    marginTop: 12,
    overflowX: "hidden",
    boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.05)",

    '& > a': {
      display: 'block',
      // border: '1px red solid',
      padding: 12,
    }
  }),
  lightLink: css({
    display: "block",
    width: "100%",
    color: "#333",
    fontSize: 16,
    fontWeight: 600,
    background: "#E8EBEC",
    padding: "8px 16px"
  })
});

export default MobileMenu;
